export default __webpack_public_path__ + "static/media/damaged-icon.b28e0d03.svg";